var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex"},_vm._l((5),function(d,i){return _c('span',{key:i,staticClass:"margin-right-2"},[(i < _vm.data)?_c('Star',{attrs:{"classStr":{ 'text-yellow-medium': i < _vm.data }}}):_c('StarOutlined',{attrs:{"classStr":'text-yellow-medium'}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }